module.exports = __webpack_public_path__ + "img/desktop.5d235e7c.png";